import React, { Component } from 'react';

import './Slide.scss';

export default class Slide extends Component {
	constructor(props) {
		super(props);
		this.state = {
			firstOpen: true
		}
	}
	componentDidUpdate() {
		if (this.state.firstOpen && this.props.isOpen) {
			this.setState({ firstOpen: false })
		}
	}
	renderClassName() {
		if(this.props.position){
			let position = ( this.props.position.slice(0,1).toUpperCase() + this.props.position.slice(1).toLowerCase() ).trim()
			let className = `Slide Slide${position} `
			if (this.props.isOpen) {
				className += `Slide${position}--opened`
			} else if (!this.state.firstOpen) {
				className += `Slide${position}--closedAnimated`
			} else {
				className += `Slide--closedStatic`
			}
			return className
		}
	}
	render() {
		return (
			<div className={this.renderClassName()}>
				{this.props.children ? this.props.children : false}
			</div>
		);
	}
}